export function applyLeaderFlags(svc, role) {
    svc.role = role;
    const myId = (typeof window !== 'undefined' && window.__ME_ID__) || '';
    const peerId = svc.partner || '';
    svc.isLeader = String(myId) < String(peerId);
    svc.isPolite = !svc.isLeader;
    console.log('[CALLDBG] leader flags', { myId, peerId, role: svc.role, isLeader: svc.isLeader, isPolite: svc.isPolite });
}
